export const getTypeFromObjectID = (objectID: string) => objectID.split('_')[0];
export const getIDFromObjectID = (objectID: string) => objectID.split('_')[1];
